(() => {
  const pad = (n) => String(n).padStart(2, '0');
  const formatTime = (seconds) => {
    if (!isFinite(seconds) || seconds < 0) return '0:00';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds - m * 60);
    return `${m}:${pad(s)}`;
  };

  const init = (root) => {
    const audio = root.querySelector('[data-audio-el]');
    const btn = root.querySelector('[data-audio-toggle]');
    const progress = root.querySelector('[data-audio-progress]');
    const currentEl = root.querySelector('[data-audio-current]');
    const durationEl = root.querySelector('[data-audio-duration]');

    if (!audio || !btn || !progress) return;

    let isSeeking = false;

    const syncUI = () => {
      const d = audio.duration || 0;
      const t = audio.currentTime || 0;

      if (durationEl) durationEl.textContent = formatTime(d);
      if (currentEl) currentEl.textContent = formatTime(t);

      if (!isSeeking && d > 0) {
        progress.value = String((t / d) * 100);
      } else if (!isSeeking && d === 0) {
        progress.value = '0';
      }
    };

    const setPlayingState = () => {
      const playing = !audio.paused && !audio.ended;
      root.classList.toggle('is-playing', playing);
      btn.setAttribute('aria-label', playing ? 'Pause audio' : 'Play audio');
    };

    btn.addEventListener('click', async () => {
      document.querySelectorAll('[data-product-audio] audio').forEach((a) => {
        if (a !== audio) a.pause();
      });

      try {
        if (audio.paused || audio.ended) {
          await audio.play();
        } else {
          audio.pause();
        }
      } catch (e) {}

      setPlayingState();
    });

    audio.addEventListener('loadedmetadata', syncUI);
    audio.addEventListener('timeupdate', syncUI);
    audio.addEventListener('durationchange', syncUI);
    audio.addEventListener('play', setPlayingState);
    audio.addEventListener('pause', setPlayingState);
    audio.addEventListener('ended', () => {
      setPlayingState();
      syncUI();
    });

    progress.addEventListener('input', () => {
      isSeeking = true;
      const d = audio.duration || 0;
      if (d > 0) {
        const pct = Number(progress.value) / 100;
        const t = Math.max(0, Math.min(d, pct * d));
        if (currentEl) currentEl.textContent = formatTime(t);
      }
    });

    progress.addEventListener('change', () => {
      const d = audio.duration || 0;
      if (d > 0) {
        const pct = Number(progress.value) / 100;
        audio.currentTime = Math.max(0, Math.min(d, pct * d));
      }
      isSeeking = false;
      syncUI();
    });

    syncUI();
    setPlayingState();

    // Ensure metadata is fetched so duration is available (especially on very short clips).
    try {
      audio.load();
    } catch (e) {}
  };

  const boot = () => {
    document.querySelectorAll('[data-product-audio]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
